<div class="modal-body">
  <div class="row">
    <div class="col-12">
      <p>
        Your budget quote has been successfully calculated. Please enter your
        contact details below to retrieve your price. We will also send you a
        copy via email.
      </p>
    </div>
  </div>
  <hr />
  <div class="row">
    <div class="col-12">
      <form [formGroup]="form" (ngSubmit)="onSubmit()" novalidate>
        <div class="mb-3 row">
          <label for="phoneNumber" class="col-3 col-form-label"
            >Phone number <small>(Optional)</small></label
          >
          <div class="col-9">
            <input
              id="phoneNumber"
              formControlName="phoneNumber"
              class="form-control"
              type="text"
            />
            <hlu-validation-message
              [validationControl]="form.get('phoneNumber')"
              validationName="required"
              errorMessage="Phone number is required"
            >
            </hlu-validation-message>
            <hlu-validation-message
              [validationControl]="form.get('phoneNumber')"
              validationName="validCountryPhone"
              errorMessage="Must be a valid UK phone number"
            >
            </hlu-validation-message>
          </div>
        </div>
        <div class="mb-3 row">
          <label for="email" class="col-3 col-form-label">Email</label>
          <div class="col-9">
            <input
              id="email"
              formControlName="email"
              class="form-control"
              type="text"
            />
            <hlu-validation-message
              [validationControl]="form.get('email')"
              validationName="required"
              errorMessage="Email is required"
            >
            </hlu-validation-message>
            <hlu-validation-message
              [validationControl]="form.get('email')"
              validationName="email"
              errorMessage="Must be a valid email"
            >
            </hlu-validation-message>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <small
              >By pressing submit, you're agreeing to our
              <a href="#">terms of service</a>.</small
            >
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <button
              type="submit"
              class="btn btn-primary"
              [disabled]="!form.valid"
            >
              Submit
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
